import { resolveCanReadPrices } from "js/frontend/mixins/price-visibility.js";

/**
 * "Also Available As": bundles that contain a product. Shared by the PDP (section + modal)
 * and the catalog ("Available in a bundle deal" opens the modal). Needs httpMixin.
 */
export const relatedBundlesMixin = {
    data() {
        return {
            relatedBundlesUrl: window.bo?.relatedBundlesUrl,
            relatedBundles: [],
            relatedBundlesTotal: 0,
            // loading finished (every page, or stopped on a failure) — not "all pages succeeded"
            relatedBundlesComplete: false,
            // bumped on every new load so a slower, older response is dropped
            relatedBundlesRequestId: 0,
            showRelatedBundleModal: false,
        };
    },

    computed: {
        relatedBundleCardOptions() {
            const bo = window.bo ?? {};

            return {
                priceOptions: resolveCanReadPrices(bo)
                    ? {
                          taxExempted: !!bo.taxExempted,
                          taxIncluded: !!bo.taxIncluded,
                          displayIncludingTax: !!bo.displayPricesDuringCartAndCheckoutIncludingTax,
                          hideLineItemTax: !!bo.hideLineItemTax,
                          currencySymbol: bo.currencySymbol,
                          fromLabel: bo.catalogTranslations?.from,
                      }
                    : null,
                showFavorite: !!bo.enabledFavoriteProduct,
                bundleLabel: bo.catalogTranslations?.bundle ?? "Bundle",
                addLabel: bo.generalTranslations?.add_to_cart ?? "Add",
            };
        },
    },

    methods: {
        // Fetches every page so the modal lists all related bundles; the PDP section shows from page 1.
        loadRelatedBundles(productId) {
            const requestId = ++this.relatedBundlesRequestId;
            this.relatedBundles = [];
            this.relatedBundlesTotal = 0;
            this.relatedBundlesComplete = false;
            this.loadRelatedBundlesPage(productId, 1, requestId);
        },

        loadRelatedBundlesPage(productId, page, requestId) {
            this.getData(
                this.relatedBundlesUrl,
                { params: { productId, limit: 50, page } },
                (response) => {
                    if (requestId !== this.relatedBundlesRequestId) {
                        return;
                    }

                    const paginator = response.data;
                    this.relatedBundles = this.relatedBundles.concat(paginator.data ?? []);
                    this.relatedBundlesTotal = paginator.total ?? this.relatedBundles.length;

                    if (paginator.current_page < paginator.last_page) {
                        this.loadRelatedBundlesPage(productId, page + 1, requestId);
                    } else {
                        this.relatedBundlesComplete = true;
                    }
                },
                (error) => {
                    if (requestId !== this.relatedBundlesRequestId) {
                        return;
                    }

                    // Supplementary list: keep what loaded and stop, never surface an error.
                    console.error("Failed to load related bundles", error);
                    this.relatedBundlesComplete = true;
                },
                false // no full-screen loading veil
            );
        },
    },
};
